
import { Observable } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

import { CoreDataActionName } from './core.data.state';

import {
  Company,
  TokenUser,
  JobType,
  Priority,
  Category,
  Code,
  Zone,
  WorkOrderStatus,
  DocumentLibrary
} from '@jms/model';

@Injectable()
export class CoreDataActions {
  public readonly users$: Observable<TokenUser[]>;
  public readonly companies$: Observable<Company[]>;
  public readonly codes$: Observable<Code[]>;
  public readonly categories$: Observable<Category[]>;
  public readonly priorities$: Observable<Priority[]>;
  public readonly workorderStatuses$: Observable<WorkOrderStatus[]>;
  public readonly jobTypes$: Observable<JobType[]>;
  // public readonly customers$: Observable<Customer[]>;
  public readonly zones$: Observable<Zone[]>;
  public readonly documents$: Observable<DocumentLibrary[]>;

  constructor(public store: Store<any>) {
    this.categories$ = store.select(x => x.categories.categories);
    this.companies$ = store.select(x => x.companies.companies);
    this.users$ = store.select(x => x.users.users);
    this.priorities$ = store.select(x => x.priorities.priorities);
    this.workorderStatuses$ = store.select(x => x.workorderStatuses.workorderStatuses);
    this.jobTypes$ = store.select(x => x.jobtypes.jobTypes);
    // this.customers$ = store.select(x => (x.customers ? x.customers.customers : []));
    this.codes$ = store.select(x => x.codes.codes);
    this.zones$ = store.select(x => x.zones.zones);
    this.documents$ = store.select(x => x.documents.documents);
  }

  public load(type: string, dispatch = true): Action {
    const action = {
      type: type
    } as Action;

    if (dispatch) this.store.dispatch(action);

    return action;
  }

  public loadUsers(dispatch = true): Action {
    return this.load(CoreDataActionName.UsersLoadAll, dispatch);
  }

  public loadCompanies(dispatch = true): Action {
    return this.load(CoreDataActionName.CompaniesLoadAll, dispatch);
  }

  public loadCodes(dispatch = true): Action {
    return this.load(CoreDataActionName.CodesLoadAll, dispatch);
  }

  public loadCategories(dispatch = true): Action {
    return this.load(CoreDataActionName.CategoriesLoadAll, dispatch);
  }

  public loadJobTypes(dispatch = true): Action {
    return this.load(CoreDataActionName.JobTypesLoadAll, dispatch);
  }

  public loadPriorities(dispatch = true): Action {
    return this.load(CoreDataActionName.PrioritiesLoadAll, dispatch);
  }

  public loadWorkorderStatuses(dispatch = true): Action {
    return this.load(CoreDataActionName.WorkorderStatusLoadAll, dispatch);
  }

  public loadQuoteStatuses(dispatch = true): Action {
    return this.load(CoreDataActionName.QuoteStatusLoadAll, dispatch);
  }

  // public loadCustomers(dispatch = true): Action {
  //   return this.load(CoreDataActionName.CustomersLoadAll, dispatch);
  // }

  public loadZones(dispatch = true): Action {
    return this.load(CoreDataActionName.ZonesLoadAll, dispatch);
  }

  public loadDocuments(dispatch = true): Action {
    return this.load(CoreDataActionName.DocumentsLoadAll, dispatch);
  }

  public actionSuccess(successAction: string, payload: any, dispatch = false) {
    const action = {
      type: CoreDataActionName.ActionSuccess,
      payload: {
        type: successAction,
        payload: payload
      }
    };

    if (dispatch) this.store.dispatch(action);

    return action;
  }

  public actionFailed(failureAction: string, error: any, dispatch = false): Action {
    const action = {
      type: CoreDataActionName.ActionFailed,
      payload: {
        type: failureAction,
        payload: error
      }
    };

    if (dispatch) this.store.dispatch(action);

    return action;
  }
}
